/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Vs_Switch_3Inputs */

const en_fc_vs_switch_3 = /** @type {(inputs: Fc_Vs_Switch_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import the XML into FilmCraft and check effects, titles and speed changes.`)
};

/**
* | output |
* | --- |
* | "Import the XML into FilmCraft and check effects, titles and speed changes." |
*
* @param {Fc_Vs_Switch_3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_vs_switch_3 = /** @type {((inputs?: Fc_Vs_Switch_3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Vs_Switch_3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_vs_switch_3(inputs)
});
export { fc_vs_switch_3 as "fc.vs.switch.3" }